import React, { useEffect, useRef, useState } from "react";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import {
  AddUserTag,
  getUsers,
  RemoveUserTag,
  setUserStoredPage,
  setUserStoredPagesize,
} from "../../../redux/features/Settings/Management/Users";

import { useLocation, useNavigate } from "react-router-dom";
import { getUserDetailsStateAction } from "../../../redux/features/users/userDetails";
import ICONS from "../../../assets/Icons";

import PaginationComponent from "../../../components/_utils/PaginationComponent";
import Loader from "../../../components/Loader/Index";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton";
import CardContainer from "../../../components/_utils/CommonViewAllCard/CardContainer";
import TextWithIcon from "../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent";
import useServiceChecker from "../../../components/ServiceChecker";
import CommonAssignTagPopup from "../../../components/_utils/CommonPopups/CommonAssignTagPoppup";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider";
import CommonToast from "../../../components/_utils/CommonToast";
import useCustomSearchParams from "../../../utils/useCustomSearchParams";
import { toast } from "react-toastify";
import accountNameStandardised from "../../../utils/accountNamestandardised";

const UsersSettings = ({
  type,
  setIsPopUpOpen,
  setPayload,
  selectedValueUser,
  flow = "",
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const { searchParam, handleSearchParams, handleClearSearchParam } =
    useCustomSearchParams({
      pageno: GlobalConfiguration.lengthCheckOne,
      pagesize: dropdownOptions[GlobalConfiguration.lengthCheckZero],
    });

  const [currentPage, setCurrentPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );

  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") ||
      dropdownOptions[GlobalConfiguration?.lengthCheckOne],
  );

  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") ||
      dropdownOptions[GlobalConfiguration?.lengthCheckOne],
  );

  const [isTagsPopupOpen, setIsTagsPopupOpen] = useState(false);
  const [multiSelect, setMultiSelect] = useState(false);
  const [, setTotalCount] = useState(false);
  const [usersDetails, setUsersDetails] = useState([]);
  const [usersArray, setUsersArray] = useState([]);
  const [mainData, setMainData] = useState([]);
  const [allTags, setAllTags] = useState([]);
  const [tagState, setTagState] = useState([]);
  const [newSelectedTags, setNewSelectedTags] = useState([]);
  const [searchUserText, setSearchUserText] = useState(
    searchParam.get("search") || "",
  );
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [loader, setLoader] = useState(true);
  const searchRef = useRef(null);
  const filterButtonRef = useRef(null);
  const filterRef = useRef(null);
  const [allData, setAllData] = useState([]);
  const [filterOpen, setFilterOpen] = useState(null);
  const [ownerTagState, setOwnerTagState] = useState(
    searchParam.get("tags") || [],
  );
  const searchButtonRef = useRef(null);
  const [, setIsOpen] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [active, setActive] = useState("");
  const [loading, setLoading] = useState(false);
  const [typedText, setTypedText] = useState("");
  const [inputData, setInputData] = useState({});
  const [sortValue, setSortValue] = useState(searchParam.get("sort") || "");
  const [selectedGrade, setSelectedGrade] = useState(
    searchParam.get("grade") || "",
  );
  const [selectedStatus, setSelectedStatus] = useState(
    searchParam.get("status") || "",
  );

  const [ensureAll] = useServiceChecker();

  const hasCreateUserService = ensureAll(["CEmp"]);

  const services = useSelector((state) => state.refreshToken.services);

  const [selectedAccount, setSelectedAccount] = useState(
    "All selected accounts",
  );
  const [selectedAssignedAccountID, setSelectedAssignedAccountID] =
    useState("");

  const selectedTagsCards = usersDetails?.filter((account) =>
    usersArray.includes(account.id),
  );
  const maxSelection = GlobalConfiguration.searchMaxLength;

  const tagActionDispatchedRef = useRef(false);

  let availableTags = mainData?.available_tags || tagState || [];

  useEffect(() => {
    sessionStorage.removeItem("userDetailsInfostorage");
  }, []);

  const handleUserDetails = (data) => {
    if (type === "popup") {
      setIsPopUpOpen(false);
      setPayload((prev) => {
        const fullName = `${data.first_name} ${data.last_name ?? ""}`.trim();
        return {
          ...prev,
          linked_user_id: data?.id,
          userName: accountNameStandardised(fullName),
          userId: data.user_id,
          ...(selectedValueUser === "username" && {
            account_name: fullName,
          }),
        };
      });
    } else {
      let userDetailsInfo = false;
      userDetailsInfo = usersDetails.filter((fil) => {
        return fil.id === data.id;
      });
      if (userDetailsInfo) {
        dispatch(setUserStoredPage(currentPage));
        dispatch(setUserStoredPagesize(selectedValue));
        navigate(`/settings/user_view_all/user_detail_page/${data.id}`, {
          state: {
            isViewAll: location.pathname.includes(`settings/user_view_all`)
              ? true
              : false,
          },
        });

        dispatch(getUserDetailsStateAction(userDetailsInfo));
        sessionStorage.setItem(
          "userDetailsInfostorage",
          JSON.stringify(userDetailsInfo),
        );
      }
    }
  };

  useEffect(() => {
    if (selectedAccount !== "All selected accounts") {
      const selectedAccountTags =
        allData?.find((account) => account.id === selectedAssignedAccountID)
          ?.account_tags || [];

      setNewSelectedTags(
        selectedAccountTags.map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );

      setAllTags(
        availableTags?.map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );
    } else if (
      selectedTagsCards?.length &&
      selectedAccount !== "All selected accounts"
    ) {
      const accountTags =
        allData?.find((account) => usersArray.includes(account.id))
          ?.account_tags || [];
      setNewSelectedTags(
        accountTags.map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );
      setAllTags(
        availableTags?.map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );
    } else if (
      selectedTagsCards?.length ||
      selectedAccount === "All selected accounts"
    ) {
      let a = allData?.filter((account) => usersArray.includes(account.id));
      const commonTags = a.reduce((common, account) => {
        return common.filter((tag) => account.account_tags?.includes(tag));
      }, a[GlobalConfiguration?.lengthCheckZero]?.account_tags || []);

      const uncommonTags = a.reduce((uncommon, account) => {
        return uncommon.concat(
          account.account_tags?.filter((tag) => !commonTags.includes(tag)) ||
            [],
        );
      }, []);

      setNewSelectedTags(
        commonTags.map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );

      setAllTags(
        [...new Set([...availableTags, ...uncommonTags])].map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );
    } else {
      setNewSelectedTags([]);
      setAllTags(
        availableTags?.map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    usersArray,
    mainData,
    selectedAssignedAccountID,
    selectedAccount,
    allData,
    selectedTagsCards?.length,
  ]);

  const handleAddTags = async (item) => {
    if (tagActionDispatchedRef) {
      tagActionDispatchedRef.current = true;
    }

    try {
      setLoader(true);

      try {
      } catch (error) {}

      CommonToast({
        text: "Assigning tag.",
        icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
        variant: "var(--processing)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });

      let response = await dispatch(
        AddUserTag({
          user_id:
            selectedAssignedAccountID !== ""
              ? [selectedAssignedAccountID]
              : usersArray,
          tags: item?.type === "newAss" ? item?.data1 : [item],
        }),
      );

      if (response?.payload?.status === true) {
        let val = allData.map((itm) => {
          if (usersArray.includes(itm.id)) {
            return {
              ...itm,
              account_tags: [
                ...new Set([
                  ...(itm.account_tags || []),
                  ...(response?.meta?.arg?.tags || []),
                ]),
              ],
            };
          }
          return itm;
        });
        setAllData(val);
        fetchData(true);
        toast.dismiss();
        CommonToast({
          text: "Tag assigned successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  const handleRemoveTags = async (item) => {
    if (tagActionDispatchedRef) {
      tagActionDispatchedRef.current = true;
    }
    try {
      setLoader(true);
      CommonToast({
        text: "Unassigning tag.",
        icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
        variant: "var(--processing)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });
      const response = await dispatch(
        RemoveUserTag({
          user_id:
            selectedAssignedAccountID !== ""
              ? [selectedAssignedAccountID]
              : usersArray,
          tags: item,
        }),
      );

      if (response?.payload?.status === true) {
        let val = allData.map((itm) => {
          if (usersArray.includes(itm.id)) {
            return {
              ...itm,
              account_tags: itm.account_tags.filter(
                (tag) => !response?.meta?.arg?.tags?.includes(tag),
              ),
            };
          }
          return itm;
        });
        fetchData(true);
        setAllData(val);
        toast.dismiss();
        CommonToast({
          text: "Tag unassigned successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  useEffect(() => {
    const handleDropDown = (e) => {
      if (searchRef.current && searchRef.current.contains(e.target)) {
      } else if (
        searchButtonRef.current &&
        searchButtonRef.current.contains(e.target)
      ) {
      } else {
        setShowSearchBar(false);
      }
    };
    document.addEventListener("click", handleDropDown);
  }, [searchRef]);

  const fetchData = async () => {
    let queryParams = {
      page_no: currentPage,
      page_size: pageSize,
      search_string: searchUserText,
      account_tags: ownerTagState,
      sort_by:
        sortValue === "Alphabetical : A to Z"
          ? "ascending"
          : sortValue === "Alphabetical : Z to A"
            ? "descending"
            : sortValue === "Order : Latest"
              ? "latest"
              : sortValue === "Order : Oldest"
                ? "oldest"
                : "ascending",
      grade: selectedGrade || undefined,
      active_status:
        selectedStatus === "Active"
          ? "Y"
          : selectedStatus === "Inactive"
            ? "N"
            : undefined,
    };

    setLoader(true);
    try {
      const response = await dispatch(getUsers(queryParams));
      const newData = response?.payload?.employees || [];
      if (!searchUserText && !ownerTagState) {
        setTagState(response?.payload?.available_tags);
      } else {
        if (sessionStorage?.getItem("UserAvailableTags")) {
          let val = sessionStorage?.getItem("UserAvailableTags");
          setTagState(JSON.parse(val) || []);
        }
      }
      setMainData(response?.payload || []);

      setTotalCount(response?.payload?.total_count);

      setLoader(false);

      setAllData((prev) => {
        return [
          ...new Map(
            [...prev, ...newData].map((item) => [item["id"], item]),
          ).values(),
        ];
      });
      setUsersDetails(newData);
    } catch (error) {
      setLoader(false);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();
    }
    if (event.key === "Enter") {
      // applyBtnRef.current.click();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (!type === "popup") {
      if (services && services?.includes("Admin")) {
        if (!services?.includes("MimicEntity")) {
          navigate("/feature_not_assigned");
        } else {
          navigate("/settings/user_view_all");
        }
      } else {
        if (services && !services?.includes("VEmp")) {
          navigate("/feature_not_assigned");
        } else {
          navigate("/settings/user_view_all");
        }
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    searchUserText,
    pageSize,
    currentPage,
    ownerTagState,
    selectedGrade,
    selectedStatus,
    sortValue,
  ]);

  const handleSelect = (value) => {
    handleSubmit("pagesize", value);
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
  };

  const handlePagination = (page) => {
    handleSubmit("pageno", page);
    setCurrentPage(page);
  };

  useEffect(() => {
    const handlefilter = (e) => {
      if (filterRef.current && filterRef.current.contains(e.target)) {
      } else if (
        filterButtonRef.current &&
        filterButtonRef.current.contains(e.target)
      ) {
      } else {
        setFilterOpen((prev) => (prev === null ? null : false));
      }
    };
    document.addEventListener("click", handlefilter);
  }, [filterRef]);

  useEffect(() => {
    let data;
    switch (active) {
      case "Tags":
        data = allTags
          ?.filter((itm) => {
            if (itm.value.startsWith(typedText)) return true;
            else return false;
          })
          ?.map(({ value }) => {
            return { id: value, Tag: value };
          });
        setInputData(data);
        setLoading(false);
        break;
      case "Search":
        setSearchUserText(typedText);
        setLoading(false);
        break;
      default:
    }
    setInputData(data);
  }, [active, allTags, typedText]);

  const handleClose = () => {
    setIsTagsPopupOpen(false);

    if (tagActionDispatchedRef.current) {
      fetchData();
      setUsersArray([]);
      setMultiSelect(false);
    }
  };

  const handleSubmit = (key, value) => {
    if (type !== "popup") handleSearchParams(key, value);
  };

  const handleClearParams = () => {
    handleClearSearchParam();

    if (showInnerSearchBar) return;
    setSearchUserText("");
    setTypedText("");
    setOwnerTagState([]);
    setSelectedGrade("");
    setSelectedStatus("");
    setCurrentPage(1);
  };

  return (
    <>
      {usersDetails?.length > 0 && (
        <div
          style={{
            zIndex: showInnerSearchBar
              ? "var(--z-index-max)"
              : "var(--z-index-max)",
            width: "var(--width-full)",
            bottom: "var(--bottom-base)",
            position: type === "popup" ? "absolute" : "fixed",
          }}
          className="fixed w-full bg-primary-nav"
        >
          {showInnerSearchBar && (
            <div
              className="roles-curtain-div-page h-full-height w-full-width fixed bg-PopUp-BackDrop opacity-dark-opacity z-z-index-overlay"
              style={{
                position: type === "popup" ? "absolute" : "fixed",
              }}
            ></div>
          )}
          <PaginationComponent
            handleSelect={handleSelect}
            selectedValue={selectedValue}
            data={mainData}
            pageSize={pageSize}
            dropdownOptions={dropdownOptions}
            handlePagination={handlePagination}
            currentPage={currentPage}
            setIsOpen={setIsOpen}
          />
        </div>
      )}
      {isTagsPopupOpen && (
        <div
          onClick={() => setIsTagsPopupOpen(false)}
          className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-max"
        >
          <CommonAssignTagPopup
            headerTitle="Assign/Unassign tags:"
            closehandleFunction={handleClose}
            closedisabledBgColor=""
            closebuttonRef=""
            closeimgColor=""
            loading={loader}
            newTags={newSelectedTags}
            handleAddTags={handleAddTags}
            handleRemoveTags={handleRemoveTags}
            setNewTags={setNewSelectedTags}
            AllTags={allTags}
            setAllTags={setAllTags}
            setLoading={setLoader}
            selectedAssignedAccountID={selectedAssignedAccountID}
            selectedAccount={selectedAccount}
            setSelectedAccount={setSelectedAccount}
            setSelectedAssignedAccountID={setSelectedAssignedAccountID}
            ownerDetailData={[
              ...new Map(allData.map((item) => [item["id"], item])).values(),
            ].filter((account) => usersArray.includes(account.id))}
            users={[
              ...new Map(allData.map((item) => [item["id"], item])).values(),
            ]
              .filter((account) => usersArray.includes(account.id))
              ?.map((ac) => ac.first_name)}
            type="userViewAll"
          />
        </div>
      )}

      <div
        className={`bg-primary-bg flex flex-col  overflow-y-hidden ${type === "popup" ? "h-height-full" : "h-screen"}`}
        style={{
          overflow: showInnerSearchBar && "hidden",
        }}
      >
        <div
          className={`h-navbar-breadcrumb-height flex-shrink-0 bg-primary-nav  hidden ${type === "popup" ? "hidden" : "Qsmd:block"}`}
        ></div>
        <TopNavComponent
          handleBack={() => navigate("/settings")}
          topNavCtaBtn1Props={
            multiSelect
              ? {
                  btnText: usersArray?.length ? "Clear" : "Cancel",
                  btnType: "button",
                  enabledBgColor: "var(--primary-nav-act)",
                  handleFunction: () => {
                    if (usersArray.length) {
                      setUsersArray([]);
                    } else {
                      setUsersArray([]);
                      setMultiSelect(false);
                    }
                  },
                  enabledTextColor: "var(--text-primary)",
                  isDisabled: filterOpen || showSearchBar,
                  hoverOption: "white",
                }
              : null
          }
          topNavCtaBtnWithIcon1Props={
            multiSelect || type === "popup"
              ? undefined
              : {
                  btnText: "Create user",
                  btnType: "button",
                  handleFunction: () => {
                    if (type === "popup") {
                      CommonToast({
                        text: "Action restricted in popup mode.",
                        icon: ICONS?.ERROR_WHITE_CIRCLE,
                        variant: "var(--error)",
                      });
                      return;
                    }
                    if (hasCreateUserService.status) {
                      navigate("/settings/users/create_user");
                    } else {
                      navigate("/feature_not_assigned", {
                        state: hasCreateUserService.unavailableService,
                      });
                    }
                  },
                  isDisabled: !hasCreateUserService.status || type === "popup",
                  enabledTextColor: "var(--primary-bg)",
                  disabledTextColor: null,
                  enabledBgColor: "var(--text-primary)",
                  disabledBgColor: null,
                  isLoading: false,
                  outLineColor: null,
                  hoverOption: "black",
                  buttonRef: null,
                  fullWidthRequired: null,
                  inActiveVariantNeeded: null,
                  isLoaderNeeded: null,
                  icon: "https://q2pay.in/new_assets/common/settings/add_button_white.svg",
                  imgColor: "var(--primary-bg)",
                  iconToBeAlign: "right",
                }
          }
          assignTagProps={
            multiSelect
              ? undefined
              : {
                  btnType: "button",
                  handleFunction: () => {
                    if (type === "popup") {
                      CommonToast({
                        text: "Action restricted in popup mode.",
                        icon: ICONS?.ERROR_WHITE_CIRCLE,
                        variant: "var(--error)",
                      });
                      return;
                    } else {
                      setMultiSelect(true);
                    }
                  },
                  isDisabled: type === "popup" ? true : false,
                  enabledTextColor: "var(--text-primary)",
                  disabledTextColor: null,
                  enabledBgColor: "var(--primary-bg)",
                  disabledBgColor: null,
                  isLoading: false,
                  outLineColor: null,
                  hoverOption: "white",
                  buttonRef: null,
                  fullWidthRequired: null,
                  inActiveVariantNeeded: null,
                  isLoaderNeeded: null,
                  // icon: "https://q2pay.in/new_assets/common/settings/add_button_white.svg",
                  // imgColor: "var(--primary-bg)",
                  iconToBeAlign: "right",
                }
          }
          ispagination={
            usersDetails?.length <= GlobalConfiguration.lengthCheckZero
              ? false
              : true
          }
          topNavCtaBtn2Props={
            multiSelect
              ? {
                  btnText: "Assign tags",
                  btnType: "button",
                  enabledBgColor:
                    multiSelect && !usersArray.length
                      ? "var(--text-disabled)"
                      : usersArray?.length
                        ? "var(--text-primary)"
                        : "var(--text-disabled)",
                  handleFunction: () => {
                    if (!usersArray.length) return;
                    setIsTagsPopupOpen(true);
                  },
                  enabledTextColor:
                    multiSelect && !usersArray?.length
                      ? "var(--text-primary)"
                      : usersArray?.length
                        ? "var(--primary-bg)"
                        : "var(--text-primary)",
                  hoverOption: "black",
                  inActiveVariantNeeded: true,

                  isDisabled:
                    multiSelect && !usersArray?.length
                      ? true
                      : usersArray?.length
                        ? false
                        : true,
                }
              : null
          }
          filteredSearchProps={{
            inputData,
            setInputData,
            showInnerSearchBar: showInnerSearchBar,
            setShowInnerSearchBar: setShowInnerSearchBar,
            active,
            setActive,
            onSearchInput: setTypedText,
            searchText: typedText,
            filterPlaceholder:
              "first name/ last name/ user ID/ full name/ contact number / email ID",
            searchPlaceholder:
              "Search by first name/ last name/ user ID/ full name/ contact number / email ID",
            isShowSortBy: true,
            isShowFilter: true,
            filterItems: [
              {
                name: "Search",
                isMulti: false,
                value: searchUserText,
                // setValue: setSearchUserText,
                setValue: (val) => {
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  handleSubmit("search", val);
                  setSearchUserText(val);
                },
                isDropdown: false,
                isDisabled: loading,
              },
              {
                name: "Tags",
                short_name: "Tag",
                isMulti: true,
                value: ownerTagState,
                setValue: (val) => {
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  handleSubmit("tags", val);
                  setOwnerTagState(val);
                },
                isDropdown: true,
                isDisabled: loading,
              },
            ],
            filters: [
              {
                name: "Grade",
                filterType: "dropdown",
                variant: "single",
                size: "small",
                value: selectedGrade,
                dropdownPlaceHolder: "Select Grade",
                isDisabled: true,
                options: mainData?.available_grades?.map((x) => x.trim()) ?? [],
                statusPop: true,
                handleChange: (val) => {
                  handleSubmit("grade", val);
                  setSelectedGrade(val);
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                },
              },

              {
                name: "Status",
                filterType: "dropdown",
                variant: "single",
                dropdownPlaceHolder: "Select status",
                size: "small",
                value: selectedStatus,
                options: ["Active", "Inactive"],
                handleChange: (val) => {
                  handleSubmit("status", val);
                  setSelectedStatus(val);
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                },
              },
            ],
            sortByFilter: [
              {
                name: "Alphabetical : A to Z",
                default: true,
              },
              {
                name: "Alphabetical : Z to A",
              },
              {
                name: "Order : Latest",
              },
              {
                name: "Order : Oldest",
              },
            ],
            // isFilterClearAllDisabled: true,
            isFilterClearAllDisabled:
              selectedGrade === "" && selectedStatus === "" ? true : false,
            // sortHandleChange: () => {},
            sortValue: sortValue,
            sortHandleChange: (val) => {
              handleSubmit("sort", val);
              setSortValue(val);
              setCurrentPage(GlobalConfiguration.lengthCheckOne);
            },
          }}
        />
        {loader && !isTagsPopupOpen ? (
          <>
            <div className="loader-container m-auto justify-center items-center flex loader-height">
              <Loader />
            </div>
          </>
        ) : usersDetails.length !== GlobalConfiguration?.lengthCheckZero ? (
          <div
            style={{
              scrollbarGutter: "stable",
            }}
            ref={filterRef}
            className={`h-full ${showInnerSearchBar ? "overflow-hidden" : "overflow-y-scroll"} ${
              usersDetails?.length === GlobalConfiguration.lengthCheckZero ||
              loading
                ? "pb-bottom-base"
                : `Qsmd:mb-[var(--pagination-height)]  ${flow === "fieldforceaccountcreate" ? "mb-[var(--pagination-height)]" : "mb-topnav-bottom-height"}`
            } `}
          >
            <div
              className={
                showInnerSearchBar
                  ? `overflow-y-hidden h-full  userviewallscroll ${
                      multiSelect && ownerTagState?.length
                        ? "userviewallscroll_respo"
                        : ""
                    } ${
                      ownerTagState?.length
                        ? "userviewallscroll_filter_cond"
                        : ""
                    } ${
                      showInnerSearchBar && multiSelect
                        ? "userviewallscroll_search_cond"
                        : ""
                    } opacity-dark-opacity bg-PopUp-BackDrop `
                  : `${
                      ownerTagState?.length
                        ? "userviewallscroll_filter_cond"
                        : ""
                    } userviewallscroll  ${
                      multiSelect && ownerTagState?.length
                        ? "userviewallscroll_respo"
                        : ""
                    }
                     ${
                       showSearchBar && multiSelect
                         ? "userviewallscroll_search_cond"
                         : ""
                     }`
              }
            >
              <div
                className={` ${multiSelect ? "usercard_resp" : ""} standard-card-alignment gap-y-gap-md gap-x-gap-sm ${showInnerSearchBar ? "opacity-dark-opacity bg-PopUp-BackDrop pointer-events-none z-z-index-overlay" : ""}`}
              >
                {showInnerSearchBar && (
                  <div
                    className="roles-curtain-div h-full-height w-full-width fixed bg-PopUp-BackDrop opacity-dark-opacity z-z-index-overlay"
                    style={{
                      position: type === "popup" ? "absolute" : "fixed",
                    }}
                  ></div>
                )}
                {usersDetails?.map((userDtls) => {
                  const isSelf =
                    userDtls.user_id === sessionStorage.getItem("user_id");
                  return (
                    <CardContainer
                      filterRef={filterRef}
                      hoverHeight={GlobalConfiguration?.userHoverHeight}
                      key={userDtls?.id}
                      context={userDtls}
                      isSelected={
                        multiSelect && usersArray?.includes(userDtls?.id)
                      }
                      isDisabled={(() => {
                        // Order of these matters
                        // So do not change
                        // Unless ofc, you need to.
                        if (type === "popup") return false;
                        if (multiSelect) return false;
                        if (ensureAll(["VSpecificEmp", "Admin"]).status)
                          return false;
                        if (ensureAll(["VSpecificEmp"]).status && isSelf)
                          return false;
                        return true;
                      })()}
                      onClickHandler={(e, context) => {
                        if (!filterOpen) {
                          if (multiSelect) {
                            e.stopPropagation();
                            if (usersArray?.includes(context.id)) {
                              setUsersArray(() => {
                                return usersArray?.filter((acc) => {
                                  return acc !== context.id;
                                });
                              });
                            } else {
                              if (usersArray?.length < maxSelection) {
                                setUsersArray([...usersArray, context.id]);
                              }
                            }
                          } else {
                            handleUserDetails(context);
                          }
                        }
                      }}
                    >
                      <card-body>
                        <TextWithIcon
                          type={"text"}
                          fontWeight={"normal"}
                          text={userDtls?.user_id}
                          subText={"User ID"}
                          textColor={"var(--text-primary)"}
                          iconComponentArray={
                            multiSelect
                              ? [
                                  {
                                    icon: usersArray?.includes(userDtls?.id)
                                      ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                                      : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg",
                                    isDisabled: false,
                                  },
                                ]
                              : []
                          }
                        />
                        <TextWithIcon
                          type={"text"}
                          fontWeight={"normal"}
                          text={[userDtls?.first_name, userDtls?.last_name]
                            .filter(Boolean)
                            .join(" ")}
                          subText="User name"
                          textColor={"var(--text-primary)"}
                        />
                      </card-body>
                      <card-hover>
                        <TextWithIcon
                          type={"text"}
                          fontWeight={"normal"}
                          text={
                            userDtls?.account_tags?.length
                              ? userDtls?.account_tags.join(", ")
                              : "No tags assigned"
                          }
                          textColor={"var(--text-primary)"}
                          iconComponentArray={[
                            {
                              icon: "https://q2pay.in/new_assets/common/view_all/assign_tag_without_circle.svg",
                              isDisabled: false,
                            },
                          ]}
                        />
                      </card-hover>
                    </CardContainer>
                  );
                })}
              </div>
            </div>
          </div>
        ) : (
          <>
            <div
              className={
                showInnerSearchBar
                  ? `h-height-full w-width-full bg-PopUp-BackDrop opacity-dark-opacity flex flex-col items-center justify-center Qmd:m-auto mx-auto my-margin-xl gap-gap-sm`
                  : `flex flex-col items-center justify-center Qmd:m-auto mx-auto my-margin-xl h-height-full gap-gap-sm ${false ? "h-auto" : ""}`
              }
            >
              <img
                src="https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                alt="No accounts found"
                className={`w-graphic-width-md h-graphic-rectangle-height-md
                  ${filterOpen ? "opacity-light-opacity" : "opacity-base-opacity"}`}
              />
              <p
                className={"text-font-sm text-text-primary items-center"}
                style={{
                  opacity: showInnerSearchBar
                    ? "var(--light-opacity)"
                    : "var(--base-opacity)",
                }}
              >
                No data found.
              </p>
              <div
                style={{
                  opacity: showInnerSearchBar
                    ? "var(--light-opacity)"
                    : "var(--base-opacity)",
                  pointerEvents: filterOpen ? "none" : "auto",
                  display:
                    ownerTagState?.length || searchUserText.length
                      ? "flex"
                      : "none",
                }}
                className="oas-selectaccount"
              >
                <PrimaryButton
                  isDisabled={showInnerSearchBar}
                  enabledBgColor="var(--primary-act)"
                  btnText="Clear parameters"
                  enabledTextColor="var(--text-primary)"
                  handleFunction={handleClearParams}
                  buttonRef={null}
                  hoverOption="white"
                />
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default UsersSettings;
